// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; // Si usas Firestore (Recomendado)
// import { getDatabase } from "firebase/database"; // Descomenta esta línea si usas Realtime Database en su lugar

// Tus credenciales de Firebase (Copia y pega las tuyas aquí)
const firebaseConfig = {
 
  apiKey: "AIzaSyCtg7vcbhJ8Qwq51lBEW2z4QShOWLWjgv0",
  authDomain: "farma-movil-32f2e.firebaseapp.com",
  projectId: "farma-movil-32f2e",
  storageBucket: "farma-movil-32f2e.firebasestorage.app",
  messagingSenderId: "301930978233",
  appId: "1:301930978233:web:3dd0395a22a2429566f468",
  measurementId: "G-LEJ31S0GSF"
};


// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Exportar la base de datos para usarla en tus páginas/componentes
export const db = getFirestore(app); 
// export const db = getDatabase(app); // Usa esta línea si elegiste Realtime Database